// src/pages/CorporateEventsPage.js
import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import '../styles/EventPackagePage.css';
import '../styles/MenuPage.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from '../components/Footer';

import ev1 from '../assets/ev1.jpg';
import ev2 from '../assets/ev2.jpg';
import ev3 from '../assets/ev3.jpg';
import ev4 from '../assets/ev4.jpg';
import ev5 from '../assets/ev5.jpg';
import ev6 from '../assets/ev6.jpg';
import ev7 from '../assets/ev7.jpg';
import ev8 from '../assets/ev8.jpg';
import ev9 from '../assets/ev9.jpg';
import ev10 from '../assets/ev10.jpg';
import ev11 from '../assets/ev11.jpg';
import ev12 from '../assets/ev12.jpg';
import ev13 from '../assets/ev13.jpg';
import ev14 from '../assets/ev14.jpg';
import corpPhoto1 from '../assets/rom2.jpg';
import corpPhoto3 from '../assets/rom10.jpg';
import corpPhoto4 from '../assets/rom9.jpg';
import corpPhoto5 from '../assets/rom11.jpg';
import corpPhoto6 from '../assets/rom12.jpg';
import corpPhoto7 from '../assets/rom23.jpg';
import corpPhoto8 from '../assets/rom24.jpg';

const IMAGES = [ev1, ev2, ev3, ev4, ev5, ev6, ev7, ev8, ev9, ev10, ev11, ev12, ev13, ev14];
const TOTAL = IMAGES.length;

const PHOTOS = [corpPhoto1, corpPhoto3, corpPhoto4, corpPhoto5, corpPhoto6, corpPhoto7, corpPhoto8];

const WHATSAPP_HREF =
  'https://wa.me/6590079953?text=Hi%20Lebua%20Thai%2C%20I%27d%20like%20to%20enquire%20about%20your%20Corporate%20Events%20packages.';

const CorporateEventsPage = () => {
  const [current, setCurrent] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 450,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    afterChange: (i) => setCurrent(i),
  };

  const prev = () => sliderRef.current.slickPrev();
  const next = () => sliderRef.current.slickNext();

  const progressPct = ((current + 1) / TOTAL) * 100;

  return (
    <div className="event-package-page">
      <header className="event-package-hero">
        <span className="event-package-hero__eyebrow">Book for Events</span>
        <h1 className="event-package-hero__title">Corporate Events</h1>
        <p className="event-package-hero__sub">
          Located in the iconic CHIJMES, Lebua Thai offers an authentic Thai
          experience with beautiful surroundings, exceptional cuisine, and
          entertainment options — perfect for corporate functions and private
          dining. Browse our events deck below for packages and details.
        </p>
        <a
          href={WHATSAPP_HREF}
          className="btn btn-primary event-package-hero__cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faWhatsapp} /> Enquire on WhatsApp
        </a>
      </header>

      <div className="menu-carousel-wrap">
        <div className="menu-slide-wrap">
          <Slider ref={sliderRef} {...settings}>
            {IMAGES.map((img, i) => (
              <div key={i} className="menu-slide">
                <img
                  src={img}
                  alt={`Corporate events deck, page ${i + 1}`}
                  loading={i === 0 ? 'eager' : 'lazy'}
                />
              </div>
            ))}
          </Slider>

          <button className="menu-arrow menu-arrow--prev" onClick={prev} aria-label="Previous page">
            &#8592;
          </button>
          <button className="menu-arrow menu-arrow--next" onClick={next} aria-label="Next page">
            &#8594;
          </button>
        </div>

        <div className="menu-counter-bar">
          <span className="menu-counter">{current + 1} / {TOTAL}</span>
          <div className="menu-progress" role="progressbar" aria-valuenow={current + 1} aria-valuemax={TOTAL}>
            <div className="menu-progress__fill" style={{ width: `${progressPct}%` }} />
          </div>
        </div>
      </div>

      <div className="event-package-grid">
        {PHOTOS.map((img, i) => (
          <div key={i} className="event-package-item">
            <img
              src={img}
              alt={`Corporate event at Lebua Thai ${i + 1}`}
              loading="lazy"
            />
          </div>
        ))}
      </div>

      <section className="event-package-reserve">
        <h2>Planning a Corporate Event?</h2>
        <p>Tell us your date, headcount, and requirements — we'll take it from there.</p>
        <a
          href={WHATSAPP_HREF}
          className="btn btn-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faWhatsapp} /> Enquire on WhatsApp
        </a>
      </section>

      <Footer />
    </div>
  );
};

export default CorporateEventsPage;
